import { HttpClient } from '@angular/common/http';
import { Injector, NgModule, isDevMode } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { IonicModule } from '@ionic/angular';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { providers } from './app.providers';
import { ComponentsModule } from './components/components.module';
import { IosInstallComponent } from './components/ios-install/ios-install.component';
import { PlyrModule } from './lib/plyr/plyr.module';
import { ApiService } from './services/api.service';
import { CustomTranslateLoader } from './services/custom-translateloader';
import { SettingsService } from './services/settings.service';
import { ServiceLocator } from './utils/service-locator';
import { ServiceWorkerModule } from '@angular/service-worker';

@NgModule({
  declarations: [
    AppComponent,
    IosInstallComponent
  ],
  imports: [
    BrowserModule,
    IonicModule.forRoot(),
    AppRoutingModule,
    PlyrModule,
    ComponentsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: CustomTranslateLoader,
        deps: [HttpClient, ApiService, SettingsService]
      }
    }),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: !isDevMode(),
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000'
    })
  ],

  providers,
  bootstrap: [AppComponent],
})
export class AppModule {

  constructor(injector: Injector) {
    ServiceLocator.init(injector);
  }

}
